<template>
    <div class="client-list">
         <ab-list-query>
            <template #right>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-input
                            placeholder="客户编号"
                            v-model.trim="formSearch.number"
                            clearable
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="4">
                        <el-input
                            placeholder="客户名称"
                            v-model.trim="formSearch.name"
                            clearable
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="4">
                        <ab-timeSearch
                            v-model="formSearch.timeRange"
                            class="searchBox"
                            startSrc="最后更新日期起"
                            endSrc="最后更新日期止"
                            @searchEvent="changeTimeRange"
                        ></ab-timeSearch>
                    </el-col>
                    <el-col :span="4" class="text-left">
                        <el-button @click="getListData">搜索</el-button>
                        <el-button link class="btn-svg" @click="formSearch={}">
                            <ab-svg name="qingchu"></ab-svg>
                            清除
                        </el-button>
                    </el-col>
                </el-row>
            </template>

            <template #toolbar>
                <el-button type="primary" @click="handlerEdit">新增</el-button>
                <el-button @click="delAddressAll">批量删除</el-button>
                <el-button @click="exportFile" :loading="btnsLoading.export">导出</el-button>
            </template>

            <template #table>
                <ab-table
                    stripe
                    showSelection
                    class="materialTable"
                    ref="table"
                    :column-list="columns"
                    showEdit
                    indexWidth="50"
                    widths="190"
                    isFilter="operator"
                    :dataListLoading="isloading"
                    :table-list="tableData"
                    @filterColumns="filterColumns"
                    :handleSelectionChange="handleSelectionChange"
                >
                    <template #operator="scope">
                        <el-button type="primary" link @click="handlerEdit(scope.row)">编辑</el-button>
                        
                        <el-button type="primary" class="word-red" link @click="removeRow(scope.row)">删除</el-button>
                    </template>
                </ab-table>
            </template>

            <template #page>
                <ab-page
                    :pageTotal="page.total"
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :pageSizes="page.pageSizes"
                    @searchForm="pageSearch"
                ></ab-page>
            </template>
        </ab-list-query>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formSearch: {},
            isloading: false,
            multiSelected: {},
            columns: [
                {
                    props: "number",
                    labels: "客户编码",
                    widths: 60,
                },
                {
                    props: "updateTime",
                    labels: "更新日期",
                    widths: 70,
                },
                {
                    props: "name",
                    labels: "客户名称",
                    widths: 60,
                },
                {
                    props: "address",
                    labels: "地址",
                    widths: 100,
                },
            ],
            tableData: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0,
            },
            btnsLoading: {
                export: false,
            }
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        filterColumns(array) {
            this.columns = array;
        },
        pageSearch(obj) {
            this.page.currentPage = obj.currentPage;
            this.page.pageSize = obj.pageSize;
            this.getListData();
        },
        changeTimeRange (obj) {
            if (obj) {
                this.formSearch.updateTimeStart = obj[0]
                this.formSearch.updateTimeEnd = obj[1]
            } else {
                this.formSearch.updateTimeStart = ''
                this.formSearch.updateTimeEnd = ''
            }
            this.getListData()
        },
        getListData() {
            this.isloading = true
            let data = Object.assign({data: this.formSearch}, {pageNum: this.page.currentPage, pageSize: this.page.pageSize})
            //添加收发货请求参数
            this.$post('/bas/client/basCustomer/list', data).then(res => {
            if (res.data.code == 'C0000') {
                this.tableData = res.data.result.list
                this.page.total = res.data.result.total
            }
            }).finally(() => {
                this.isloading = false
            })
        },
        //编辑
        handlerEdit(row){
            this.$router.push({
                path: '/client-detail',
                query: {
                    action: 'detail',
                    id: row.id,
                    cache: false
                }
            })
        },
        //多选
        handleSelectionChange(arr){
            this.multiSelected = arr
        },
        //删除
        removeRow(row){
            this.$confirm(`确定删除该行数据数据？`, '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$get('/bas/client/basCustomer/del', {id: row.customerPrincipalId}).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.$message({
                            type: 'success',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                        this.getListData()
                    }
                })
            })
        },
        //导出
        exportFile () {
            this.btnsLoading.export = true
            this.formSearch.columns = this.columns.map(row => { return row.props })
            let data = Object.assign({data: this.formSearch}, {pageNum: this.page.currentPage, pageSize: this.page.pageSize})
            this.$post('/bas/client/basCustomer/exportByColumns', data).then(({ data }) => {
                if (data.code === 'C0000') {
                    this.$message.success(data.message)
                    let eleLink = document.createElement('a')
                    eleLink.download = ''
                    eleLink.style.display = 'none'
                    // 字符内容转变成blob地址
                    eleLink.href = data.result
                    // 触发点击
                    document.body.appendChild(eleLink)
                    eleLink.click()
                    // 然后移除
                    document.body.removeChild(eleLink)
                }
            }).finally(() => {
                this.btnsLoading.export = false
            })
        }
    },
}
</script>

<style lang="scss">
    .client-list{
        .ab-list-query{
            .el-menu.el-menu--horizontal{
                display: none;
            }
        }
    }
</style>